import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg
  xmlns="http://www.w3.org/2000/svg"
  className={className}
  viewBox="0 0 36 36"
  aria-hidden="true"
>
  <rect width="36" height="36" rx="18" fill="#F5F5F5" />

  <clipPath id="clip_8_8_20_20">
    <rect x="8" y="8" width="20" height="20" />
  </clipPath>

  <g clipPath="url(#clip_8_8_20_20)">
    <path
      d="M21.4784 18.833H11.3325V17.1663H21.4784L16.8117 12.4997L17.9992 11.333L24.6659 17.9997L17.9992 24.6663L16.8117 23.4997L21.4784 18.833Z"
      fill="currentColor"
    />
  </g>
</svg>
);

export default Icon;
